import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Button,
  Form,
  FormFeedback,
  Alert,
  Spinner,
} from "reactstrap";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link, useLocation, useNavigate } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import OTPInput from "react-otp-input";
import OtpTimer from "otp-timer";

// actions
import {
  loginUser,
  socialLogin,
  resetLoginFlag,
  resendPhoneOtp,
  VerifyUser,
} from "../../slices/thunks";

import logoLight from "../../assets/images/logo-light.png";
import { createSelector } from "reselect";
//import images
import BNRathiLogo from "../../assets/images/BNRathiLogo.png";
import LoginPageLogo from "../../Components/Common/LoginPageLogo";

const VerifyCode = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  // console.log("location", location);
  const selectLayoutState = (state) => state;
  const loginpageData = createSelector(selectLayoutState, (state) => ({
    user: state.Account.user,
    error: state.Login.error,
    loading: state.Login.loading,
    errorMsg: state.Login.errorMsg,
  }));
  // Inside your component
  const { user, error, loading, errorMsg } = useSelector(loginpageData);

  const [userLogin, setUserLogin] = useState([]);
  const [otp, setOtp] = useState("");
  const [passwordShow, setPasswordShow] = useState(false);

  useEffect(() => {
    if (user && user) {
      const updatedUserData =
        process.env.REACT_APP_DEFAULTAUTH === "firebase"
          ? user.multiFactor.user.email
          : user.user.email;
      const updatedUserPassword =
        process.env.REACT_APP_DEFAULTAUTH === "firebase"
          ? ""
          : user.user.confirm_password;
      setUserLogin({
        email: updatedUserData,
        password: updatedUserPassword,
      });
    }
  }, [user]);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: location.state?.email || "",
      // password: userLogin.password || "123456" || "",
    },

    onSubmit: (values) => {
      // console.log("values",values)
      values.otp = otp;
      // values.phone_number = location.state?.phone_number;
      values.type = "NCbvyt";
      dispatch(
        VerifyUser({
          user: values,
          token: location?.state?.token,
          history: props.router.navigate,
        })
      )
        .then((res) => {
          if (res.code === 200) {
            navigate("/set-password", {
              replace: true,
              state: { token: location?.state?.token },
            });
          }
        })
        .catch((err) => {
          // console.log("err", err);
        });
      // navigate("/set-password");

      // dispatch(loginUser(values, props.router.navigate));
    },
  });

  const signIn = (type) => {
    dispatch(socialLogin(type, props.router.navigate));
  };

  //handleTwitterLoginResponse
  // const twitterResponse = e => {}

  //for facebook and google authentication
  const socialResponse = (type) => {
    signIn(type);
  };

  useEffect(() => {
    if (errorMsg) {
      setTimeout(() => {
        dispatch(resetLoginFlag());
      }, 3000);
    }
  }, [dispatch, errorMsg]);

  const handleResendOtp = () => {
    // console.log("resend otp function");
    dispatch(resendPhoneOtp(location?.state?.token));
  };

  document.title = "Basic SignIn | B.N. Rathi";
  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="auth-page-content">
          <Container>
            <Row className="justify-content-center">
              <Col md={12} lg={10} xl={10} className="">
                <Card className="mt-4 mb-0">
                  <CardBody className="p-0">
                    <Row className="m-0 p-0">
                      
                    <LoginPageLogo />
                      <Col xxl={6} xl={6} lg={6} md={6} sm={12} className="p-0">
                        <div className="p-4">
                          <div className="text-center mt-2">
                            <h3 className="text-dark mb-1">Forgot Password?</h3>
                            <p className="text-muted fs-p-sm">
                            Enter the OTP sent to your mobile number{" "}
                              <span className="text-primary fw-semibold">{`+91 ${location.state?.phone_number}`}</span> and on email <span className="text-primary fw-semibold">{location.state?.email}</span>
                            </p>
                          </div>
                          {error && error ? (
                            <Alert color="danger"> {error} </Alert>
                          ) : null}
                          <div className="p-2 mt-4">
                            <Form
                              onSubmit={(e) => {
                                e.preventDefault();
                                validation.handleSubmit();
                                return false;
                              }}
                              action="#"
                            >
                              <div className="mb-4">
                                <Label className="form-label">OTP*</Label>
                                <OTPInput
                                  value={otp}
                                  inputStyle={"otpBox"}
                                  containerStyle={
                                    "w-100 justify-content-between "
                                  }
                                  onChange={setOtp}
                                  numInputs={4}
                                  skipDefaultStyles
                                  shouldAutoFocus
                                  inputType="tel"
                                  // renderSeparator={<span>{" "}</span>}
                                  renderInput={(props) => <input {...props} />}
                                />
                              </div>

                              <div className="mt-4">
                                <Button
                                  color="primary"
                                  disabled={otp.length!=4 ||  loading }
                                  className="btn btn-primary w-100"
                                  type="submit"
                                >
                                  {loading ? (
                                    <Spinner size="sm" className="me-2">
                                      {" "}
                                      Loading...{" "}
                                    </Spinner>
                                  ) : null}
                                  Verify OTP
                                </Button>
                              </div>
                              <div className="w-100 mt-4 text-center d-flex align-items-center justify-content-center">
                                <p className="mb-0 fs-p-bg">
                                  Haven’t received OTP?{" "}
                                </p>
                                <span className=" cursor-pointer text-primary fw-semibold otpTimer">
                                  <OtpTimer
                                    minutes={0}
                                    seconds={60}
                                    text="Try again in"
                                    ButtonText="Resend Code"
                                    resend={() => handleResendOtp()}
                                    textColor={"#1261A6"}
                                    className=" otpTimer"
                                    buttonColor={"#1261A6"}
                                    background={"#fff"}
                                  />
                                </span>
                              </div>
                            </Form>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>

                <div className="mt-4 text-center">
                  <p className="mb-2 text-white">
                    Have another account ?{" "}
                    <span
                      onClick={() => {
                        navigate("/login");
                      }}
                      className="fw-semibold text-white text-decoration-underline cursor-pointer"
                    >
                      {" "}
                      Back to Signin{" "}
                    </span>{" "}
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default withRouter(VerifyCode);
